import { APIModel } from "app/state/api";
import { CMSApiCallModel } from "../../interfaces";

const pagesExplorerSector: CMSApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_CMS_API}/pages-explorer-sector`),
};

export default pagesExplorerSector;
